// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__nAYh4","pageLoader":"Spinner_pageLoader__bpmNB"};